import { NextPage } from 'next';

import { OrderActionButtonsProvider } from '~/modules/board/hooks/useOrderActionButtons';
import { TicketsProvider } from '~/modules/board/hooks/tickets';
import { KeyActionsProvider } from '~/modules/board/hooks/keyActions';
import { ConsolidateProvider } from '~/modules/board/hooks/consolidate';
import { SignIn } from '~/modules/auth/pages/SignIn';

import { withSSRGuest } from '~/shared/utils/withSSRGuest';
import { ModalProvider } from '~/shared/hooks/useModal';

export const getServerSideProps = withSSRGuest(async () => {
  return {
    props: {},
  };
});

const SignInPage: NextPage = () => (
  <OrderActionButtonsProvider>
    <TicketsProvider>
      <ConsolidateProvider>
        <KeyActionsProvider>
          <ModalProvider>
            <SignIn />
          </ModalProvider>
        </KeyActionsProvider>
      </ConsolidateProvider>
    </TicketsProvider>
  </OrderActionButtonsProvider>
);
export default SignInPage;
